import styled from '@emotion/styled'
import { Button } from 'app/components/Common/Button'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { useVocabularyData } from 'app/utils/vocabulary'
import { Link } from 'gatsby'
import React, { memo } from 'react'

export interface Props {
  image?: ImageProps
  languageCode: string
  title: string
  URL: string
}

export const Offer = memo(function Offer({
  image,
  languageCode,
  title,
  URL,
}: Props) {
  if (!title || !URL) {
    return null
  }

  return (
    <Container to={URL}>
      {image ? <Image {...image} /> : null}
      <Wrapper>
        <Title>{title}</Title>
        <CTA
          label={useVocabularyData('find-out-more', languageCode)}
          noActions
        />
      </Wrapper>
    </Container>
  )
})

const Container = styled(Link)`
  display: block;
  height: 100%;
  position: relative;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.variants.neutralDark1};
    opacity: 0.5;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
`

const Wrapper = styled.div`
  position: absolute;
  bottom: 3rem;
  left: 3rem;
  z-index: 3;

  @media (max-width: 1023px) {
    bottom: 1.875rem;
    left: 1.875rem;
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.375rem;
  font-weight: 500;
  line-height: 1.875rem;
`

const CTA = styled(Button)`
  background: ${({ theme }) => theme.colors.variants.primaryLight1};
  margin-top: 1.5rem;
  &:after {
    background: ${({ theme }) => theme.colors.variants.neutralDark1};
  }

  @media (max-width: 1023px) {
    margin-top: 1.125rem;
  }
`
